


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class Container extends Vue {
  @Prop({ default: false }) isMobileScreen;
  private userLang: string = 'en';

  get imageUrl() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${vxm.users.getCompanyCode}/CANDIDATEPORTAL/DownloadAppsBackground.png`;
  }

  get classNames(): string {
    return this.isMobileScreen ? '' : 'p-5';
  }
  onChangeUserLang() {
    vxm.users.setUserLang(this.userLang);
    window.location.reload();
  }
  get supportedTranslationLanguages() {
    const langs = vxm.configs.getGlobalConfigValue('SUPPORTED_TRANSLATION_LANGUAGES');
    if(langs) return langs.split(',');
    return [];
  }

  mounted() {
    this.userLang = vxm.users.getUserLang;
  }
}
